var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { MdMenu } from 'react-icons/md';
import { Box, Flex, Link, Logo, UserDropdown, VisuallyHidden, IconDropdown, Icon } from "./..";
import { useToggle, useBreakpoint } from "../../hooks";
import styled from "../../styled";
import { ApplicationMenu } from './ApplicationMenu';
var HeaderWrapper = styled(Flex)(function (_a) {
    var theme = _a.theme;
    return "\n  a, a:active {\n    text-decoration: none;\n    color: " + theme.colors.white + ";\n  }\n  ";
});
export var Header = function (_a) {
    var productName = _a.productName, _b = _a.productNameIsVisible, productNameIsVisible = _b === void 0 ? true : _b, _c = _a.productNameLss, productNameLss = _c === void 0 ? {} : _c, logo = _a.logo, _d = _a.homeUrl, homeUrl = _d === void 0 ? '/' : _d, _e = _a.isSticky, isSticky = _e === void 0 ? true : _e, _f = _a.applications, applications = _f === void 0 ? [] : _f, _g = _a.linkComponent, HeaderLink = _g === void 0 ? Link : _g, user = _a.user, customUserActions = _a.customUserActions, changePassword = _a.changePassword, headerActions = _a.headerActions, _h = _a.logoutUrl, logoutUrl = _h === void 0 ? '/logout' : _h, _j = _a.supportUrl, supportUrl = _j === void 0 ? 'https://support.lucidhq.com' : _j, children = _a.children, mobileDropdownContent = _a.mobileDropdownContent, isMobileMenuOpen = _a.isMobileMenuOpen, onMobileMenuToggle = _a.onMobileMenuToggle, mobileContentLss = _a.mobileContentLss, lss = _a.lss, _k = _a.userDropdownLss, userDropdownLss = _k === void 0 ? {} : _k;
    var _l = __read(useToggle(), 2), userDropdownIsOpen = _l[0], toggleUserDropdown = _l[1];
    var isSmallScreen = useBreakpoint('smallscreen');
    return (React.createElement(HeaderWrapper, { as: "header", lss: __assign({ position: isSticky ? 'sticky' : 'relative', top: 0, height: '4.25rem', px: 'sm', alignItems: 'center', bg: 'primary500', color: 'white', zIndex: 'header', desktop: {
                px: 'md'
            } }, lss) },
        React.createElement(Flex, { as: "nav", lss: {
                alignItems: 'center',
                width: '100%'
            } },
            !isSmallScreen && mobileDropdownContent && (React.createElement(IconDropdown, { isOpen: isMobileMenuOpen, onToggle: onMobileMenuToggle, ariaLabel: "header dropdown menu", isResponsive: false, icon: React.createElement(Icon, { as: MdMenu, size: 32 }), showArrow: true, contentProps: {
                    position: 'right',
                    lss: __assign({ maxHeight: '18.75rem', overflowY: 'auto', top: '2.875rem' }, mobileContentLss)
                }, buttonProps: { lss: { p: 'none' } }, render: function () { return mobileDropdownContent; } })),
            React.createElement(Flex, { lss: {
                    alignItems: 'center',
                    mr: 'md'
                } },
                React.createElement(HeaderLink, { to: homeUrl },
                    React.createElement(Box, { lss: { ml: isSmallScreen ? 'sm' : 'lg', mr: 'xs' } }, !!logo ? (logo) : (React.createElement(Logo, { size: isSmallScreen ? 28 : 24, width: isSmallScreen ? 55 : 50, height: isSmallScreen ? 22 : 20 })))),
                productNameIsVisible && isSmallScreen ? (React.createElement(HeaderLink, { to: homeUrl, lss: __assign({ textScale: 'content', fontWeight: 'medium', color: 'white', mx: 'lg' }, productNameLss) }, productName)) : (React.createElement(VisuallyHidden, { as: "h1" }, productName))),
            isSmallScreen && children,
            React.createElement(Flex, { lss: { flex: 1, justifyContent: 'flex-end', alignItems: 'center' } },
                headerActions,
                React.createElement(ApplicationMenu, { applications: applications }),
                user && (React.createElement(UserDropdown, { isOpen: userDropdownIsOpen, onToggle: toggleUserDropdown, user: user, changePassword: changePassword, customActions: customUserActions, logoutUrl: logoutUrl, supportUrl: supportUrl, userDropdownLss: userDropdownLss }))))));
};
//# sourceMappingURL=Header.js.map